<template>
    <div id="ActivityPc" class="w2">
        <ElForm class="search-sort-group">
            <ElFormItem label="搜尋">
                <label for="searchInput" class="visually-hidden">搜尋</label>
                <ElInput
                    id="searchInput"
                    v-model.lazy="queryItems.keyword"
                    @change="updateRoute('keyword', queryItems.keyword)"
                    placeholder="請輸入欲搜索關鍵字"
                    title="搜尋關鍵字"
                >
                    <i class="icon-search" @click="submitSearch"></i>
                </ElInput>
            </ElFormItem>
            <ElFormItem label="排序">
                <label for="orderTypeSelect" class="visually-hidden">排序</label>
                <ElSelect
                    id="orderTypeSelect"
                    v-model="queryItems.orderType"
                    placeholder="請選擇排序方式"
                    @change="updateRoute('orderType', queryItems.orderType)"
                    title="選擇排序方式"
                >
                    <ElOption label="新到舊" value="desc"></ElOption>
                    <ElOption label="舊到新" value="asc"></ElOption>
                </ElSelect>
            </ElFormItem>
        </ElForm>
        <div class="main-wrap">
            <aside>
                <ActivityPcFilter></ActivityPcFilter>
            </aside>
            <main>
                <!-- ActivityItem 部分保持不變 -->
                <ActivityItem
                    v-for="(item, index) in beachSearchData"
                    :key="'activity-item-' + index"
                    :item="item"
                ></ActivityItem>

                <div class="activity-pagination">
                    <div class="activity-pagination-total">
                        <span>
                            總計 {{ totalBeachSearchData }} 筆活動資料
                        </span>
                    </div>

                    <!-- 分頁控制元件 -->
                    <ElPagination
                        layout="prev, pager, next"
                        :total="totalBeachSearchData"
                        :page-size="10"
                        v-model:currentPage="queryItems.pageIndex"
                        @update:current-page="updateRoute('pageIndex', queryItems.pageIndex)"
                        prev-text="上一頁"
                        next-text="下一頁"
                        aria-label="分頁導航"  
                    >
                    </ElPagination>

                    <div class="activity-pagination-jump">
                        <label for="page-select" class="visually-hidden">跳轉至頁面</label>  <!-- 添加 label 標籤 -->
                        <span>跳轉至</span>
                        <ElSelect
                            id="page-select"
                            v-model="queryItems.pageIndex"
                            @change="updateRoute('pageIndex', queryItems.pageIndex)"
                            aria-label="選擇頁面"  
                        >
                            <ElOption
                                v-for="item in Math.ceil(totalBeachSearchData / 10)"
                                :key="'page-option-' + item"
                                :label="item"
                                :value="item"
                            ></ElOption>
                        </ElSelect>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActivityPc',
}
</script>
<script setup>
import { reactive, ref } from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import ActivityPcFilter from './ActivityPcFilter.vue'
import ActivityItem from './ActivityItem.vue'
import {
    ElForm,
    ElFormItem,
    ElInput,
    ElSelect,
    ElOption,
    ElPagination,
} from 'element-plus'
import { getBeachActivities } from '@/service/apis.js'
import { initQueryItems, updateRoute } from '@/utils/query.js'
const route = useRoute()

onBeforeRouteUpdate((to, from) => {
    initBeachSearchData(to.query)
    initQueryItems(queryItems, to.query)
    if (to.query.pageIndex && to.query.pageIndex !== from.query.pageIndex) {
        window.scroll({
            top: 0,
            left: 0,
        })
    }
})

const beachSearchData = ref([])
const totalBeachSearchData = ref(0)
async function initBeachSearchData(query) {
    let res = await getBeachActivities(query)
    beachSearchData.value = res.beachActivities
    totalBeachSearchData.value = res.totalCount
}
initBeachSearchData(route.query)

// 初始化 query 數據
const queryItems = reactive({
    keyword: '',
    orderType: '',
    pageIndex: 1,
})
initQueryItems(queryItems)
</script>
<style lang="scss" scoped>
#ActivityPc {
    .main-wrap {
        display: flex;
    }
    aside {
        flex: 0 0 285px;
    }
    main {
        flex: 1 1 900px;
        padding-left: 30px;
    }
}
.el-form.search-sort-group:deep() {
    margin: 20px auto;
    display: flex;
    justify-content: flex-end;
    .el-form-item {
        margin-left: 20px;
    }
    i.icon-search {
        cursor: pointer;
    }
}
.activity-pagination:deep() {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0 80px;
    color: $gray6;
    font-size: 12px;
    .el-pagination {
        button:focus-visible {
            outline: auto;
        }
        .el-pager {
            li {
                color: $gray6;
                font-size: 500;
            }
            li.is-active {
                color: $white;
                background-color: $theme1;
                border-radius: 50%;
            }
        }
    }
    .activity-pagination-jump {
        .el-select {
            margin-left: 10px;
            width: 70px;
        }
    }
}

.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
</style>
